import(/* webpackMode: "eager" */ "/home/ubuntu/download/69ae55e0886e10001459d1f2/xinyuee/src/app/not-found.tsx");
